<template>
<div>
    <topfind class="top_tab" :path="path" v-if="path ==='/启动页查看'|| path ==='/作文查看' ||path ==='/优秀作文查看'|| path==='/文章查看修改'?false:true"></topfind>
   
        <dia :dialog="dialog"></dia>
        <litable
        :listdata="wordList"
        :col-configs="tablist"
        :page="page"
        :path="path"
        :pagesize="pageInputOver"
        v-if="path==='/启动页查看'||path==='/作文查看'||path==='/优秀作文查看'?false:true"
        >
        <el-table-column slot="opt" label="操作" width="300px">
            <template slot-scope="scope">
                <div class="buttom_c">
                        <el-button size="mini" @click="handleClick(scope.row,'查看')">查看</el-button>
                        <el-button size="mini" @click="handleClick(scope.row,'编辑')" v-if="buttom.chageStauts">编辑</el-button>
                        <el-button size="mini" @click="handleClick(scope.row,'发布')" v-if="buttom.getOn" >发布</el-button>
                        <el-button size="mini"  @click="handleClick(scope.row,'下架')" v-if="buttom.remove" >下架</el-button>
                        <el-button size="mini" @click="handleClick(scope.row,'删除')" v-if="buttom.deleteStauts">删除</el-button>
                </div>
            </template>  
        </el-table-column>
        </litable>
       <div class="article_watch" v-if="path ==='/文章查看修改'">
        <el-form label-position="right" label-width="90px" :model="row" :rules='rules' :disabled="row.status === '查看'">
            <el-form-item label="文章序号:"  prop="name">
                <el-input v-model="row.文章序号"></el-input>
            </el-form-item>
            <!-- <el-form-item label="活动区域">
                <el-input v-model="formLabelAlign.region"></el-input>
            </el-form-item> -->
            <el-form-item label="文章名称"  prop="name">
                <el-input v-model="row.文章名称"></el-input>
            </el-form-item>
            <el-form-item label="作者"  prop="name">
                <el-input v-model="row.作者"></el-input>
            </el-form-item>
             <el-form-item label="核心词"  prop="name">
                <el-input v-model="row.核心词" ></el-input>
            </el-form-item>
             <el-form-item label="页码"  prop="name">
                <el-input v-model="row.页码"></el-input>
            </el-form-item>
              <el-form-item
                    v-for="(domain, index) in row.句子"
                    :label="'句子'+(index+1)"
                    :key="domain.key"
                    prop="domain"
                    maxlength="30"
                >
                <div class="domain">
                     <el-input v-model="domain.value"></el-input>
                    <el-button v-if="row.句子.length <= 1?false:true" @click.prevent="removeDomain(domain)" type="info" icon="el-icon-delete" circle></el-button>
                     <el-button @click="addDomain" v-if="row.句子.length-1 === index?true:false" type="info" icon="el-icon-plus"  circle=""></el-button>

                </div>
                   
                </el-form-item>
             <!-- <el-form-item label="句子">
                <el-input v-model="row.句子"></el-input>
            </el-form-item> -->
               <el-form-item label="音频文件">
                    <el-upload
                        class="upload-demo"
                        ref="customUpload"
                        :action="target+'file/upload'"
                        :data="tokenchange"
                        :before-upload="handleBeforeUpload"
                        :on-success="handsuccess"
                        :on-remove="imgremove"
                        :on-exceed="handleExceed"
                        :on-change="upl"
                        multiple
                        accept='.mp3,.m4a,*.cda,.wav,.aac,.wma,.ogg,.flac,.ape,.wav,.amr,.3gpp,.he-aac'
                        :limit="1"
                        :auto-upload="false"
                        >
                    <el-button size="small" type="primary" >点击上传</el-button>
                    <p>{{row.文件}}</p>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传mp3文件，且不超过500kb</div> -->
            </el-upload>
            </el-form-item>
            <el-form-item >
                <div class="starUp_button">
                 <el-button @click="goback">取消</el-button>
                <el-button  type="primary" @click="save">保存</el-button>
                </div>
              
            </el-form-item>
           
        </el-form>
       </div>
       <div class="starUp" v-if="path ==='/启动页查看'">
        <el-form label-position="right"   :model="row" :disabled="row.status === '查看'"  class="starUp_row">
            <el-form-item >
                <!-- <el-upload
                 class="avatar-uploader"
                    ref="customUpload"
                    action="/file/upload"
                    :show-file-list="false"
                    :data="tokenchange"
                    :on-success="handsuccess"
                    :on-exceed="handleExceed"
                    :on-change="upl"
                     :limit="1"
                    :auto-upload="false"
                    >
                    
                     <img v-if="starup.imageUrl" :src="starup.imageUrl" class="avatar">
                     <img v-else-if="row.图片预览" :src="row.图片预览" class="avatar" >
                    <i class="el-icon-plus upload" v-else></i>
                </el-upload> -->
                 <div class="row_up">
                    
                <el-upload
                    ref="customUpload"
                   :action="target+'file/upload'"
                    :on-preview="handlePictureCardPreview"
                    :data="tokenchange"
                    :before-upload="handleBeforeUpload"
                    :on-success="handsuccess"
                    :on-remove="imgremove"
                    :on-exceed="handleExceed"
                    :on-change="upl"
                    :limit="1"
                    accept='.png,.jpg,.jpeg'
                    :auto-upload="false"
                    :file-list="imgurl[0].url === undefined ?false:imgurl"
                     list-type="picture-card"
                     v-if="row.status != '查看'"
                    >
                     <!-- <img v-if="starup.imageUrl" :src="starup.imageUrl" >
                     <img v-else-if="row.img" :src="row.img" > -->
                    <i class="el-icon-plus"></i>
                        
                </el-upload>
                 <img :src="row.图片预览" width="148px" height="148px" @click="awsm.status = true"  v-if="row.status === '查看'" >
              </div>
            </el-form-item>
            <!-- <el-form-item label="图片:">
                <img :src="row.图片预览" alt="">
            </el-form-item> -->
            <!-- <el-form-item label="活动区域">
                <el-input v-model="formLabelAlign.region"></el-input>
            </el-form-item> -->
            <div>
                <el-form-item>
                    <div class="star_radio">
                         <el-radio v-model="radio" label="1">无</el-radio>
                     <el-radio v-model="radio" label="2">链接</el-radio>
                    </div>
                </el-form-item>
                <el-form-item >
                <div class="link" v-if="radio ==='2'">
                    <p>链接地址:</p>
                <el-input v-model="row.link" class="ad_input" ></el-input>
                </div>
            </el-form-item>
                
            </div>
        </el-form>
        <div class="starUp_button">
                 <el-button @click="goback">{{row.status === '查看'?'返回':'取消'}}</el-button>
               
                <el-button  type="primary" @click="getOn" :disabled="row.status === '查看'">发布</el-button>
        </div>
       </div>
       <div class="composition" v-if="path ==='/作文查看'">
        <el-form label-position="right" label-width="100px"  :model="row" :disabled="row.status === '查看'" ref="composition" :rules="composition" >
            <el-form-item label="作文题目:" prop="作文题目">
              <el-input v-model="row.作文题目" maxlength="25"></el-input>
            </el-form-item>
            <!-- <el-form-item label="活动区域">
                <el-input v-model="formLabelAlign.region"></el-input>
            </el-form-item> -->
            <el-form-item label="详情:"  prop="详情">
                <el-input v-model="row.详情" type="textarea" :rows="4" maxlength="100"></el-input>
            </el-form-item>
             <el-form-item label="班级:" prop="下发班级">
                    <el-select v-model="row.下发班级" placeholder="请选择">   
                        <el-option :label="item.name" :value="item.id" v-for="(item,index) in sClass" :key="index"></el-option>
                    </el-select>
            </el-form-item>
         
        </el-form>
             <div class="starUp_button">
                 <el-button @click="goback">{{row.status === '查看'?'返回':'取消'}}</el-button>
                 <el-button  type="primary" @click="save" :disabled="row.status === '查看'">提交</el-button>
                <el-button  type="primary" @click="getOn" :disabled="row.status === '查看'">发布</el-button>
          </div>
       </div>
        <div class="awesomeComposition" v-if="path ==='/优秀作文查看'">
            <el-form label-position="right" label-width="100px" ref="awesome" :model="row" :rules='zuowen' :disabled="row.status === '查看'" >
            <el-form-item label="作文题目:" prop="作文题目">
              <el-input v-model="row.作文题目" maxlength="25"></el-input>
            </el-form-item>
            <!-- <el-form-item label="活动区域">
                <el-input v-model="formLabelAlign.region"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名:" prop="姓名">
                <el-input v-model="row.姓名" maxlength="25"></el-input>
            </el-form-item>
           
              <el-form-item label="下发班级:" prop="下发班级">
                    <el-select v-model="row.下发班级" placeholder="请选择">   
                        <el-option :label="item.name" :value="item.id" v-for="(item,index) in sClass" :key="index"></el-option>
                    </el-select>
            </el-form-item>
             <el-form-item label="上传图片:" >
              <div class="row_up">
                    
                <el-upload
                    ref="customUpload"
                    :action="target+'file/upload'"
                    :on-preview="handlePictureCardPreview"
                    :data="tokenchange"
                    :on-remove="imgremove"
                    :before-upload="handleBeforeUpload"
                    :on-success="handsuccess"
                    :on-exceed="handleExceed"
                    :on-change="upl"
                    :limit="1"
                    accept='.png,.jpg,.jpeg'
                    :auto-upload="false"
                    :file-list="imgurl[0].url === undefined ?'':imgurl"
                     list-type="picture-card"
                     v-if="row.status != '查看'"
                    >
                     <!-- <img v-if="starup.imageUrl" :src="starup.imageUrl" >
                     <img v-else-if="row.img" :src="row.img" > -->
                    <i class="el-icon-plus"></i>
                        
                </el-upload>
                 <img :src="row.img" width="148px" height="148px" @click="awsm.status = true"  v-if="row.status === '查看'" >
              </div>
                
            </el-form-item>
          
        </el-form>
          <div class="starUp_button">
                 <el-button @click="goback">{{row.status === '查看'?'返回':'取消'}}</el-button>
                 <el-button  type="primary" @click="save" :disabled="row.status === '查看'">提交</el-button>
                <el-button  type="primary" @click="getOn" :disabled="row.status === '查看'">发布</el-button>
          </div>
              
       </div>

<el-dialog
  title="提示"
  :visible.sync="deletelog"
  width="300px"
 >
 <div class="dialog_delete">
       <p>确认要删除吗</p>
 </div>

  <span slot="footer" class="dialog-footer">
    <el-button @click="deletelog = false">取 消</el-button>
    <el-button type="primary" @click="deleteobj(deleteadd)">确 定</el-button>
  </span>
</el-dialog>
 <el-dialog :visible.sync="awsm.status" >
                        <img width="100%" :src="row.img" v-if="row.img && row.status === '查看'">
                        <img width="100%" :src="row.图片预览" v-if="row.图片预览  && row.status === '查看'">
                        <img width="100%" :src="awsm.url" >
</el-dialog>
         <!-- <el-table
            :data="wordList"
            border
            style="width: 100%"
        >
             <el-table-column
                :prop="item"
                :label="item"
                v-for="(item,index) in tablist" :key="index"
            >
            </el-table-column>
            <el-table-column
                label="操作"
           >
            <template slot-scope="scope"  fixed="right">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                <el-button type="text" size="small">编辑</el-button>
            </template>
            </el-table-column>
        </el-table>     -->

    
    <el-footer>
<div class="block"  v-if="path==='/启动页查看'||path==='/作文查看'||path==='/优秀作文查看'?false:true">
    <p>每页条数</p>
    <el-input v-model="pageInput" @change="pageSizeChange" class="page_input" size="mini"></el-input>
  <el-pagination
 
      @current-change="getather"
      :current-page.sync="currentPage"
      :page-size="pageInputOver"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
</div>
    </el-footer>
</div>
</template>
<script>
import moment from 'moment'
import litable from '@/components/li-table'
import topfind from '@/components/Topmenu'
import dia from '@/components/li-dialog'
import testServer from '@/api/management.js'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
export default {
    data () {
        return {
            row:{},
            pageInputOver:20,
            pageInput:20,
            ciRow:{},
            role:'',
            ddd:{
                page:''
            },
            updataStatus:false,
            target:'',
            deleteadd:'',
            currentPage:'',
            deletelog:false,
            buttom:{
                  chageStauts:true,
                  deleteStauts:false
            },
            article:{
                star:''
                },
            starup:{
                imageUrl:'',
                status:''
            },
            awsm:{
                status:false,
                url:""
            },
            imgurl:[{
                url:''
            }],
            radio:'1',
            dialog:{
                dialogFormVisible:false,
                title:"",
                url:"",
                form:'',
                checkpolintld:'',
                id:''
            },
        composition:{
          作文题目: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
          详情: [
            { required: true, message: '请输入', trigger: 'change' }
          ],
          下发班级: [
            { required: true, message: '请选择一个', trigger: 'change' }
          ],
        },
        zuowen: {
          作文题目: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
          姓名: [
            { required: true, message: '请输入', trigger: 'change' }
          ],
          下发班级: [
            { required: true, message: '请选择一个', trigger: 'change' }
          ],
        },
             rules: {
                    name: [
                        {  message: '请输入', trigger: 'blur' },
                        {  required: true, message:'请填写', trigger: 'blur' }
                    ],
                  
                    qing: [
                            {message:'请输入',trigger:'blur'},
                        {required:true,min: 1, max: 200,message:'最多输入200个字符',trigger:'blur'}
                    ],
                    domain: [
                        {  message: '请输入', trigger: 'blur' },
                        { required: true,min: 1, max: 50,  message: '最多输入50个字符', trigger: 'change' }
                    ]
        
        },
            jsonlist:'',
            imgRemoveStatus: false
        }
    },
    computed:{
        tokenchange(){
      return {
        token: JSON.parse(sessionStorage.getItem('token')).token
        }
    },
        ...mapState( 'managlist', ['wordList','tablist','sClass','total','page','find']),
    },
    components: {
        litable,
        topfind,
        dia
    },
    methods: {
         ...mapMutations('managlist',['class_List']),
        ...mapActions('managlist', ['FETCH_CHECKPOINT_LIST','FETCH_WORD_LIST','FETCH_ARTICLE_STAR','FETCH_ARTICLE_LIST','FETCH_STARTUPPAGE_LIST','FETCH_COMPOSITION_LIST','FETCH_AWESOMECOMPOSITION_LIST']),
    // findclass(id){
    //      for (let index = 0; index < this.sClass.length; index++) {
    //                                     if ( this.sClass[index].name = id) {
    //                                         return this.sClass[index].id
    //                                     }
                                        
    //                         }
    // },
    pageSizeChange(value){
        console.log(value)
        this.pageInputOver = value
        this.find.pageSize = value
        this.changeIndex(this.path,this.find)
    },
    upl(file,filelist){
        console.log('ada',file)
        this.row.文件 = undefined
        console.log(filelist)
        this.updataStatus = true
       this.starup.imageUrl = URL.createObjectURL(file.raw)
    },
    // handleSizeChange(val){
    //     console.log(val)
    // },
    getather(val){
        this.ddd.page = val
      
        sessionStorage.setItem('page',val)
        if (this.find === '') {
             this.changeIndex(this.path,this.ddd)
        } else {
              this.find.page = val
             this.changeIndex(this.path,this.find)
        }
       
       
    },
    goback(){
        console.log('adjaidjasidasjdsaijdsai',this.ddd)
        switch (this.path) {
            case '/启动页查看':
                   this.$router.push({
                                    name:'启动页管理',
                                    query:{
                                        page:this.$route.query.page
                                    }
                                }) 
                break;
        
            case '/作文查看':
                  this.$router.push({
                                    name:'作文题目发放',
                                    query:{
                                        page:this.$route.query.page
                                    }
                                }) 
                break;
            case '/优秀作文查看':
                  this.$router.push({
                                    name:'优秀作文展示',
                                    query:{
                                        page:this.$route.query.page
                                    }
                                }) 
                break

        }
      
        
    },
    handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件 `);
    },
     handlePictureCardPreview(file) {
        this.awsm.url = file.url;
        this.awsm.status = true;
    },
    imgremove(){
        console.log('w11w1')
         this.updataStatus = false
       this.imgRemoveStatus = true
    },
    save(){
       switch (this.path) {
           case '/文章查看修改':
                 if(this.row.文件 === undefined){
                this.$refs.customUpload.submit();
                } else {
                    let  sentenceJson  = []
                    for (let index = 0; index < this.row.句子.length; index++) {
                        sentenceJson.push(this.row.句子[index].value)
                    }
                let change = {
                            id:this.row.id,
                            serialNumber:this.row.文章序号,
                            name:this.row.文章名称,
                            author:this.row.作者,
                            coreWords:this.row.核心词,
                            pageNumber:this.row.页码,
                            sentenceJson:JSON.stringify(sentenceJson),
                            star:this.article.star,
                            audio: this.row.文件
                        }
                    testServer.article.save(change).then(res =>{
                        if( res.data.status === 0 ){
                            this.$router.push({
                                                    name:'文章查看',
                                                    query:{
                                                        star:this.article.star
                                                    }
                                                }) 
                            
                        }
                    })           
                        }
               break;
       
           case '/启动页查看':
               this.starup.status = 1
            if (this.updataStatus === true) {
                   if(this.row.图片 === undefined){
                    this.$refs.customUpload.submit();
               } else { 
                   let add = {
                        id:this.row.id,
                        img:this.row.图片,
                        link:this.row.link,
                        status: this.starup.status
                    }
                    testServer.startupPage.save(add).then(res =>{
                        // eslint-disable-next-line no-console
                        console.log(res)
                    })
               }
            } else {
                 const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '请上传文件')
                                    });
            }
              
               break;
          case '/作文查看':
        this.$refs['composition'].validate((valid) => {
          if (valid) {
           if ( typeof(this.row.下发班级)  === 'number') {
               testServer.composition.save({
                    classId:this.row.下发班级,
                    title:this.row.作文题目,
                    description:this.row.详情,
                    status:1,
                    id:this.row.id
                 }).then(res =>{
                    if(res.data.status === 0){
                          this.$router.push({
                                    name:'作文题目发放',
                                  
                                }) 
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                             })
                } else {
                testServer.composition.save({
                    classId:this.row.classId,
                    title:this.row.作文题目,
                    description:this.row.详情,
                    status:1,
                    id:this.row.id
                 }).then(res =>{
                    if(res.data.status === 0){
                          this.$router.push({
                                    name:'作文题目发放',
                                  
                                }) 
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                             })
                }
                
          } else {
            console.log('error submit!!');
            return false;
          }
        });
           
            break
            case '/优秀作文查看':
                 this.starup.status = 1
        this.$refs['awesome'].validate((valid) => {
          if (valid) {
              if (this.updataStatus === true) {
                     if(this.imgRemoveStatus || this.row.img === undefined){
                     this.$refs.customUpload.submit();
                    }else {
                     let parse = {
                              id:this.row.id,
                              classId:this.row.下发班级,
                              title:this.row.作文题目,
                              name:this.row.姓名,
                              img:this.row.img,
                              status:1
                          }
                          console.log(this.row.下发班级)
                      if (typeof(this.row.下发班级)  === 'number') {
                          testServer.awesomeComposition.save(parse).then(res =>{
                              console.log(res)
                               if(res.data.status === 0){
                                  const h = this.$createElement;
                            this.$notify({
                                  
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });  
                          this.$router.push('/优秀作文展示')
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                            
                          })
                      } else {
                          parse.classId = this.row.classId
                           testServer.awesomeComposition.save(parse).then(res =>{
                              if(res.data.status === 0){
                                  const h = this.$createElement;
                            this.$notify({
                                  
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });  
                          this.$router.push('/优秀作文展示')
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                          })
                      }
                }
                
              } else {
                  const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '请上传文件')
                                    });
              }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
                 
                break
       }
       
     },
     getOn(){
         console.log('1w1',this.row.link)
           this.starup.status = 0
           switch (this.path) {
               case '/启动页查看':
        if (this.updataStatus === true) {
                if(this.radio ==='2'&& (this.row.link === undefined || this.row.link === null || this.row.link === '')){
                       const h = this.$createElement;
                    this.$notify({
                        title: '标题名称',
                        message: h('i', { style: 'color: #000'}, '请添写链接')
        });
                   } else {
                       // eslint-disable-next-line no-console
                   console.log(this.row.status)
                   if(this.row.status === '添加'){
                     this.$refs.customUpload.submit();
                   } else {
                         if(this.imgRemoveStatus){
                     this.$refs.customUpload.submit();
                        } else { 
                            let add = {
                                    id:this.row.id,
                                    img:this.row.图片预览,
                                    link:'',
                                    status: this.starup.status
                                }
                                if (this.radio ==='2') {
                                   add.link = this.row.link 
                                } else {
                                    add.link = ''
                                }
                                testServer.startupPage.save(add).then(res =>{
                                    // eslint-disable-next-line no-console
                                    console.log(res)
                                    this.goback()
                                })
                        }
                   }
              
                   }
                         
        } else {
             const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '请上传文件')
                                    });
        }
                  
               
                   break;
           
                case '/作文查看':
             this.$refs['composition'].validate((valid) => {
          if (valid) {
           if ( typeof(this.row.下发班级)  === 'number') {
                      testServer.composition.save({
                    classId:this.row.下发班级,
                    title:this.row.作文题目,
                    description:this.row.详情,
                    status:0,
                    id:this.row.id
                 }).then(res =>{
                    if(res.data.status === 0){
                          this.$router.push({
                                    name:'作文题目发放',
                                  
                                }) 
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                             })
                } else {
                    testServer.composition.save({
                    classId:this.row.classId,
                    title:this.row.作文题目,
                    description:this.row.详情,
                    status:0,
                    id:this.row.id
                 }).then(res =>{
                    if(res.data.status === 0){
                          this.$router.push({
                                    name:'作文题目发放',
                                  
                                }) 
                    }  else {
                         const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
                    }
                             })
                }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
               
                
            break
             case '/优秀作文查看':
            this.starup.status = 0
                 this.$refs['awesome'].validate((valid) => {
                if (valid) {
                   if (this.updataStatus === true) {
                         if(this.imgRemoveStatus || this.row.img === undefined){
                    
                     this.$refs.customUpload.submit();
                        }
                 else {
                   
                     let parse = {
                              id:this.row.id,
                              classId:this.row.下发班级,
                              title:this.row.作文题目,
                              name:this.row.姓名,
                              img:this.row.img,
                              status:this.starup.status
                          }
                      if (typeof(this.row.下发班级)  === 'number') {
                          console.log(this.row.下发班级)
                          testServer.awesomeComposition.save(parse).then(res =>{
                               this.$router.push('/优秀作文展示')
                              console.log(res)
                          })
                      } else {
                          parse.classId = this.row.classId
                             console.log(this.row.下发班级)
                           testServer.awesomeComposition.save(parse).then(res =>{
                                this.$router.push('/优秀作文展示')
                              console.log(res)
                          })
                      }
                 }  
                   } else {
                        const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '请上传文件')
                                    });
                   }
                } else {
                            console.log('error submit!!');
                            return false;
                        }
                });
             break
           }
     },
    removeDomain(item) {
        var index = this.row.句子.indexOf(item)
        if (index !== -1) {
          this.row.句子.splice(index, 1)
        }
      },
      addDomain() {
        this.row.句子.push({
          value: '',
          key: Date.now()
        });
      },
     handsuccess(response){
       switch (this.path) {
           case '/文章查看修改':
        this.fileSuseese  = response.status
      if(response.status === 0){
                    let  sentenceJson  = []
                for (let index = 0; index < this.row.句子.length; index++) {
                    sentenceJson.push(this.row.句子[index].value)
                }
                console.log(sentenceJson)
                    let change = {
                        id:this.row.id,
                        serialNumber:this.row.文章序号,
                        name:this.row.文章名称,
                        author:this.row.作者,
                        coreWords:this.row.核心词,
                        pageNumber:this.row.页码,
                        sentenceJson:JSON.stringify(sentenceJson),
                        star:this.article.star,
                        audio: response.data
                    }
                testServer.article.save(change).then(res =>{
                    if( res.data.status === 0 ){
                        this.$router.push({
                                                name:'文章查看',
                                                query:{
                                                    star:this.article.star
                                                }
                                            }) 
                        
                    }
                })
     }
               break;
       
           case '/启动页查看':
     if(response.status === 0){
          let add = {
             id:this.row.id,
             img:response.data,
             link:this.row.link,
             status: this.starup.status
         }
         if (this.radio !='2') {
             add.link = ''
         } else {
             add.link = this.row.link
         }
        
         testServer.startupPage.save(add).then(res =>{
             // eslint-disable-next-line no-console
             console.log(res)
             this.goback()
         })
     }    
               break;
        case '/优秀作文查看':
          if(response.status === 0){
            
         let add = {
             id:this.row.id,
             name:this.row.姓名,
            classId:this.row.下发班级,
            title:this.row.作文题目,
             img:response.data,
             status: this.starup.status
         }
             if (typeof(this.row.下发班级)  === 'number') {
                    add.classId = this.row.下发班级
                       
            } else {
                    add.classId = this.row.classId
                          
                        
                }
          testServer.awesomeComposition.save(add).then(res =>{
             // eslint-disable-next-line no-console
             console.log(res)
            if ( res.data.status===0) {
                 this.$router.push('/优秀作文展示')
            } else {
                  const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, res.data.msg)
                                    });
            }
              
         })
     }     
            break
    }
    
    },
     
     async  handleClick(row,status){
            // eslint-disable-next-line no-console
          console.log('点击按钮',row,status)
         
          console.log(this.path)
          switch (status) {
              case '查看':
                  console.log(2222)
                   row.status = '查看'
                switch (this.path) {
                        case '/词库管理':
                              this.$router.push({
                                    name:'词库查看',
                                    query:{
                                        star:row.星级,
                                        id:row.id
                                    }
                                })
                            break;
                          case '/词库查看':
                              console.log(12121)
                                this.deleteStauts = true
                                this.dialog.title = '词语查看' 
                                this.dialog.url= {name:'词语查看',stauts:status},
                                this.dialog.form= row
                                this.dialog.form.star = this.$route.query.star
                                this.dialog.dialogFormVisible = true
                                console.log(this.dialog)
                            break;
                           case '/文章管理':
                              this.$router.push({
                                    name:'文章查看',
                                    query:{
                                        star:row.文章星级
                                    }
                                }) 
                            break;
                            case '/文章查看':
                               
                                 this.$router.push({
                                    name:'文章查看修改',
                                    query:{
                                        row:row
                                    }
                                }) 
                                break
                            case '/启动页管理':
                              this.$router.push({
                                    name:'启动页查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                            break;
                             case '/作文题目发放':
                              this.$router.push({
                                    name:'作文查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                            break;
                             case '/优秀作文展示':
                              this.$router.push({
                                    name:'优秀作文查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                            break;
                        }
                  break;
             case '编辑':
                 switch (this.path) {
                     case '/词库查看':
                         
                                this.dialog.title = '词语编辑' 
                                this.dialog.url= {name:'词语编辑',stauts:status},
                                row.checkpointId =this.$route.query.id
                                row.star = this.$route.query.star
                                this.dialog.form= row
                         this.dialog.dialogFormVisible = true
                         break;
                 
                     case '/文章查看':
                         this.$router.push({
                                    name:'文章查看修改',
                                    query:{
                                        row:row,
                                        page:this.ddd.page
                                    }
                                }) 
                         break;
                    case '/启动页管理':
                        if(row.状态 ==='已发布'){
                            const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '已经发布的不能编辑')
                                    });
                        } else{
                            this.$router.push({
                                    name:'启动页查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                        }
                              
                         break;
                    case '/作文题目发放':
                        if(row.发布状态 ==='已发布'){
                            const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '已经发布的不能编辑')
                                    });
                        } else{
                             this.$router.push({
                                    name:'作文查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                        }
                        break
                      case '/优秀作文展示':
                      if (row.状态 === '下架') {
                                  this.$router.push({
                                    name:'优秀作文查看',
                                    query:{
                                        row: this.row = row,
                                         page:this.ddd.page
                                    }
                                }) 
                      } else {
                            this.$message.warning(` 已发布不能编辑 `);
                      }
                            break;
                 }
                 break
              case '删除':
                 
                  if(this.path ==='/词库查看'){
                          row.queryid = this.$route.query.id
                                this.dialog.title = '词语编辑' 
                                this.dialog.url= {name:'词语编辑',stauts:status},
                                this.dialog.form= row
                            this.dialog.dialogFormVisible = true
                    //    await   testServer.word.delete({id:row.id})
                    //       this.FETCH_WORD_LIST( {id:this.$route.query.id}
                  } else if( this.path === '/文章查看'){
                       
                           row.queryid = this.$route.query.id
                                this.dialog.title = '文章编辑' 
                                this.dialog.url= {name:'词语编辑',stauts:status},
                                this.dialog.form= row
                            this.dialog.dialogFormVisible = true
                         
                    
                  } else {
                      console.log('11111',row)
                       this.deleteadd = row
                        this.deletelog = true
                  }
                  break;
                case '发布':
                    switch (this.path) {
                        case '/启动页管理':
                            if(row.状态 === '已发布'){
                                
                            } else {
                                 let add = {
                                        id:row.id,
                                        img:row.图片预览,
                                        link:row.link,
                                        status: 0
                                        
                                    }
                                   await testServer.startupPage.save(add).then(res =>{
                                        // eslint-disable-next-line no-console
                                        console.log(res)
                                    })
                                    this.FETCH_STARTUPPAGE_LIST(this.find)
                            }
                            break;
                    
                        case '/作文题目发放':
                                if (row.发布状态 === '已发布') {
                                    
                                } else{
                                    let add = {
                                        id:row.id,
                                        classId:row.classId,
                                        title:row.作文题目,
                                        description:row.详情,
                                        status:0
                                    }
                                 await testServer.composition.save(add).then(res =>{
                                         console.log(res)
                             })
                                  this.FETCH_COMPOSITION_LIST(this.find)
                                }
                            
                            break;
                            case '/优秀作文展示':
                            this.starup.status = 0
                        await  testServer.awesomeComposition.save({
                              classId:row.classId,
                              title:row.作文题目,
                              name:row.姓名,
                              img:row.img,
                              status:0,
                              id:row.id
                          }).then(res =>{
                              console.log(res)
                          
                          })
                        this.FETCH_AWESOMECOMPOSITION_LIST(this.find)
                      
                
              
                break
                    }
                    break;
                   case '下架':
                       switch (this.path) {
                        case '/启动页管理':
                            if(row.状态 === '下架'){
                                
                            } else {
                                 let add = {
                                        id:row.id,
                                        img:row.图片预览,
                                        link:row.link,
                                        status: 1
                                    }
                                 await   testServer.startupPage.save(add).then(res =>{
                                        // eslint-disable-next-line no-console
                                        console.log(res)
                                    })
                                    this.FETCH_STARTUPPAGE_LIST(this.find)
                            }
                            break;
                    
                       case '/作文题目发放':
                                if (row.发布状态 === '下架') {
                                    
                                } else{
                                   
                                    let add = {
                                        id:row.id,
                                        classId: row.classId,
                                        title:row.作文题目,
                                        description:row.详情,
                                        status:1
                                    }
                                     await testServer.composition.save(add).then(res =>{
                                         console.log(res)
                             })
                                      this.FETCH_COMPOSITION_LIST(this.find)
                                }
                            
                            break;
                            case '/优秀作文展示':
                            this.starup.status = 1           
                        await   testServer.awesomeComposition.save({
                              classId:row.classId,
                              title:row.作文题目,
                              name:row.姓名,
                              img:row.img,
                              status:1,
                              id:row.id
                          }
                          ).then(res =>{
                              console.log(res)
                              
                          })
                           this.FETCH_AWESOMECOMPOSITION_LIST(this.find)
                      
                
              
                break
                    }
          }
        //   switch (this.path) {
        //       case '/词库管理':
        //         if(row.页面 ==='词库管理'){
        //               this.FETCH_WORD_LIST(row.id)
        //         }  else {
        //             this.deleteStauts = true
        //               this.$dialog({
        //                 title: '词语查看',
        //                 url: {name:'词语查看',stauts:status},
        //                 form: row
        //                 })
        //         }
              
        //           break;
        //       default:
        //           break;
        //   }
        //   sessionStorage.setItem('watchID',JSON.stringify({id:row.id}))
        //   this.$router.push({path:'/查看',query:{id:row.id}})
          },
        onSubmit(){
            // eslint-disable-next-line no-console
            console.log(this.formInline)
        },
     async  deleteobj(row){
         // eslint-disable-next-line no-console
         console.log('删除时间',this.deleteadd)
              switch (this.path) {
                    
                      case '/启动页管理':
                          console.log(row.id)
                         await testServer.startupPage.delete({id:row.id}).then(res =>{
                              console.log(res)
                          })
                          this.FETCH_STARTUPPAGE_LIST(this.find)
                         break
                      case '/作文题目发放':
                          console.log(row.id)
                          await testServer.composition.delete({id:row.id}).then(res =>{
                              console.log(res)
                          }) 
                          this.FETCH_COMPOSITION_LIST(this.find)
                          break
                      case '/优秀作文展示':
                          await testServer.awesomeComposition.delete({id:row.id}).then(res =>{
                              console.log(res)
                          })
                          this.FETCH_AWESOMECOMPOSITION_LIST(this.find)
                  }
                  this.deletelog = false
        },
       
        dateFormat(row, column,){
            // eslint-disable-next-line no-console
               console.log(row,column)
            let date = row[column.property];
            // eslint-disable-next-line no-console
            // console.log(date)
            if (date == undefined) {
             return "";
          }
            return moment(date).format('YYYY-MM-DD')
        },
    async changeIndex(path,data){
        // console.log('dadawdawda',data)
        switch (path) {
        case '/词库管理':
            // console.log('addadsaas',data)
            this.buttom.chageStauts = false
            this.buttom.deleteStauts = false
           await this.FETCH_CHECKPOINT_LIST( data)
        //    console.log(this.wordList)
            break;
        case '/词库查看':
             this.buttom.deleteStauts = true 
            if(data === undefined){
               
                await   this.FETCH_WORD_LIST( {id:this.$route.query.id})
            }else{
                if(data.data[0] === undefined && data.data[1] === undefined){ 
               
                } else{
                data.beginTime=data.data[0],
                data.endTime=data.data[1]
                 }
                   data.id = this.$route.query.id
                 
                 await   this.FETCH_WORD_LIST(data)
            }
            break;
        case '/文章管理':
          await  this.FETCH_ARTICLE_STAR(data)
            this.buttom.chageStauts = false
            this.buttom.deleteStauts = false    
            break;
        case '/文章查看':
            this.buttom.deleteStauts = true
            this.article.star = sessionStorage.setItem('articlStar',JSON.stringify(this.$route.query.star)) 
            if (data === undefined) {
                 await this.FETCH_ARTICLE_LIST({star:this.$route.query.star})
            } else {
                  data.star = this.$route.query.star
           await console.log('121211',data)
            await this.FETCH_ARTICLE_LIST(data)
            }
            break
        case '/文章查看修改':
             this.article.star = JSON.parse(sessionStorage.getItem('articlStar') ) 
            this.row = this.$route.query.row
            console.log('/文章查看修改',this.row)
            break
        case '/启动页管理':
          await  this.FETCH_STARTUPPAGE_LIST(data)
          this.buttom.getOn = true
          this.buttom.remove = true
           this.buttom.deleteStauts = true
            break;
        case '/启动页查看':
           this.row = this.$route.query.row
           if (this.row.图片预览) {
               this.updataStatus = true
           }
           if ( this.row.link === 'undefined' || this.row.link === null || this.row.link === '') {
               this.radio = '1'
           } else {
               this.radio = '2'
           }
           this.imgurl[0].url = this.row.图片预览
           console.log('启动页查看',this.row)
           break
        case '/作文题目发放':
          await  this.FETCH_COMPOSITION_LIST(data)
         if(this.role !='admin'){
               this.buttom.getOn = true
          this.buttom.remove = true
          this.buttom.deleteStauts = true
          this.buttom.chageStauts = true
         } else{
          this.buttom.chageStauts = false
          this.buttom.getOn = false
          this.buttom.remove = false
          this.buttom.deleteStauts = false  
         }
            break;
         case '/作文查看':
           this.row = this.$route.query.row
           console.log(this.row)
           break
        case '/优秀作文展示':
         await   this.FETCH_AWESOMECOMPOSITION_LIST(data)
         if(this.role !='admin'){
               this.buttom.getOn = true
          this.buttom.remove = true
          this.buttom.deleteStauts = true
          this.buttom.chageStauts = true
         } else{
          this.buttom.chageStauts = false
          this.buttom.getOn = false
          this.buttom.remove = false
          this.buttom.deleteStauts = false  
         }
        
            break;
        case '/优秀作文查看':
           this.row = this.$route.query.row
           if (this.row.img) {
              this.updataStatus = true 
           }
           this.imgurl[0].url = this.row.img
           console.log(this.row)
           break
    
    }
    
        }
    },
    // watch:{
    // async $route(to,from,next){
    // // eslint-disable-next-line no-console
    // console.log(from.path);
    // await this.changeIndex(from.path)
    // }
  
    // },
//     beforeRouteEnter (to, from, next) {
//     // 在渲染该组件的对应路由被 confirm 前调用
//     // 不！能！获取组件实例 `this`
//     // 因为当守卫执行前，组件实例还没被创建
//     console.log(to)
//     console.log(from)
//     console.log(next)
//      next(vm => {
//        vm.changeIndex(to.path)
//     })
//   },
// async beforeRouteLeave (to, from, next) {
//     // 导航离开该组件的对应路由时调用
//     // 可以访问组件实例 `this`
//      console.log(to)
//     console.log(from)
//     console.log(next)
//     this.path = to.path
//   await  this.changeIndex(to.path)
//     next()
//   },

   async created () {
       this.find = ''
       this.path = this.$route.path
        this.ddd.page = this.$route.query.page
        this.currentPage = this.ddd.page
        console.log(this.ddd)
        await  this.changeIndex(this.$route.path,this.ddd)
         this.find.pageSize = this.pageInput
        console.log('第一次请求11111')
         this.list = this.wordList
         this.config = this.tablist
    //    await this.created(); this.mounted();
   },
   async  mounted () {
let proEnv = require('../../config/pro.env');  // 生产环境
const env = process.env.NODE_ENV;
let target = '';
if(env==='production'){  // 生产环境
  target = proEnv.hosturl+'/';
}else{  // 本地环境
  target = '/'
}
this.target =target
         // eslint-disable-next-line no-console
    console.log(this.$route.path) 
    this.role =JSON.parse( sessionStorage.getItem('role')).role
    //  await this.changeIndex(this.$route.path)
    // eslint-disable-next-line no-console
     console.log(this.wordList)
     console.log(this.role)
     console.log(this.total)
    //   this.list = this.wordList
    }
}
</script>
<style lang="scss" scoped>
.el-page-header{
    margin: 25px 20px;
}
.top_tab{
    margin-bottom: 10px;
}
.el-container{
    height: 100%
}
.el-main{
    height: 100%;
    overflow: auto;
    .row_up{
        display: flex;
    }
    .buttom_c{
        display: flex;
        flex-wrap: wrap;
         justify-content: flex-start;
         align-content:center;
        .el-button{
            margin-left: 0;
            margin-right: 10px;
            margin-top: 10px;
        }
    }
    .domain{
        display: flex;

    }
    .article_watch{
         padding:0 36% 0 20% ;
    }
    .avatar-uploader{
            height: 500px;
            width: auto; 
                    border-radius: 6px;
                    cursor: pointer;
                    position: relative;
                    margin-bottom: 50px;
           
        }
         .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .ad_input{
            width: 500px;
        }
        .upload{
         width: 350px;
         height: 350px;
        background: #fff;
        line-height: 350px;  
        }
        .avatar {
           width: auto;
            height: 500px;
            display: block;
        }
    .starUp{

        margin: 0 auto;
        .starUp_row{
         display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        }
       .star_radio{
           width: 100%;
           margin: 0 auto;
           display: flex;
           justify-content: center;
       }
        .link{
            display: flex;
            justify-content: center;
            align-items: center;
            p{
                   width: 80px;
                    margin-block-start: 0em;
                    margin-block-end: 0em;
            }
        }
        
        .starUp_button{
          display: flex;
          justify-content: center;
          align-items: center;
        }
    }
    .composition{
         margin: 0 auto;
        padding:0 36% 0 20% ;
         .starUp_button{
          display: flex;
          justify-content: center;
          align-items: center;
        }
    }
    .awesomeComposition{
          margin: 0 auto;
        padding:0 30% 0 30% ;
         .starUp_button{
          display: flex;
          justify-content: center;
          align-items: center;
        }
    }
}
.dialog_delete{
      margin: 0 auto;
    padding: 0 10%;
    p{
            margin-block-start: 0em;
    margin-block-end: 0em;
     font-size: 15px;
    }
   
}
.block{
    margin-top: 5px;
    float:right;
    display: flex;
    justify-content: center;
    align-items: center;
    .page_input{
        width: 50px;
        font-size: 14px;
       
        .el-input__inner{
            height: 30px;
        }
     
    }
}
.el-header{
  height: 100px;
}
</style>
